<template>
    <div>
        <div class="__img-gallery-container2" itemscope itemtype="http://schema.org/ImageGallery">
            <template v-for="(item,index) in screenshots">
                <figure :key="index"
                        itemprop="associatedMedia"
                        itemscope
                        itemtype="http://schema.org/ImageObject">
                    <a :href="item.src" itemprop="contentUrl" :data-size="`${item.w}x${item.h}`">
                        <img :src="item.msrc" :alt="item.alt" itemprop="thumbnail"/>
                    </a>
                    <figcaption style="display: none" itemprop="caption description">{{item.title}}</figcaption>
                </figure>
            </template>
        </div>
        <PhotoSwipeCore/>
    </div>
</template>

<script>
    import PhotoSwipeCore from "../../../../components/Gallery/PhotoSwipeCore";

    export default {
        name: "ClockServerGallery",
        components: {PhotoSwipeCore},
        mounted() {
            PhotoSwipeCore.methods.initPhotoSwipeFromDOM('.__img-gallery-container2', {
                loop: true,
                shareEl: false
            });
        },
        data() {
            return {
                screenshots: [
                    {
                        src: require("../../../../assets/pages/features/screenshots/clock-server/big/interface OneB Clock-server_1.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/clock-server/small/interface OneB Clock-server_1 prew.jpg"),
                        alt: 'picture1',
                        title: 'Image Caption 1',
                        w: 800,
                        h: 600
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/clock-server/big/interface OneB Clock-server_2.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/clock-server/small/interface OneB Clock-server_2 prew.jpg"),
                        alt: 'picture2',
                        title: 'Image Caption 2',
                        w: 1280,
                        h: 720
                    }
                ]
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../../theme/theme";

    .__img-gallery-container2 {
        display: grid;
        grid-column-gap: 2rem;

        img {
            width: 100%;
            transition: all .25s;
            border: 2px solid $text20;
        }

        img:hover {
            border: 2px solid $back20;
        }
    }

    @media (max-width: 40rem) {
        .__img-gallery-container2 {
            grid-template-columns: 1fr ;
        }
    }


    @media (min-width: 40rem) {
        .__img-gallery-container2 {
            grid-template-columns: repeat(2, minmax(8rem, 10rem));
        }
    }
</style>
